import {
  ACTIVITY_TYPES,
  USER_TYPES,
  OFFER_TYPES,
  OFFER_STATUSES,
} from '../constants'

let propertyId = 1

export const propertyFixture = (dataOverride = {}) => ({
  property_address: '1 Mauchly',
  property_city: 'Irvine',
  property_county: 'Orange',
  property_state: 'CA',
  property_zip: '92618',
  status_label: 'Pending',
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  global_property_id: propertyId++,
  auction_number: 'O-ibmo',
  ...dataOverride,
})

const biddingStatusFixture = (dataOverride = {}) => ({
  open_contract_url: 'https://auction.com/contract-url',
  ...dataOverride,
})

export const suggestedOffersFixture = () => ({
  // offer's mlh_property_id
  5034619: {
    suggested_offer_low: 350000,
    suggested_offer_high: 420000,
  },
  5034615: {
    suggested_offer_low: 200000,
    suggested_offer_high: 260000,
  },
  5034627: {
    suggested_offer_low: 190000,
    suggested_offer_high: 230000,
  },
  5034635: {
    suggested_offer_low: 300000,
    suggested_offer_high: 350000,
  },
})

// Fixtures for 'Active' tab
export const pendingOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [],
  amount: 400000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-20T23:23:30Z',
  mlh_property_id: 5034619,
  offer_expiration_date: '2019-12-27T23:23:30Z',
  offer_id: 91,
  offer_status: OFFER_STATUSES.PENDING,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-20T23:23:30Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const reviewedOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.REVIEWED_BY_SELLER,
      created_by: 6348361,
      created_date: '2019-12-20T23:33:59Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-20T23:33:59Z',
      user_type: USER_TYPES.SELLER,
    },
  ],
  amount: 300000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-20T23:23:10Z',
  mlh_property_id: 5034617,
  offer_expiration_date: '2019-12-27T23:23:10Z',
  offer_id: 90,
  offer_status: OFFER_STATUSES.PENDING,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-20T23:23:10Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const counterOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [],
  amount: 250000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-20T23:35:48Z',
  mlh_property_id: 5034615,
  offer_expiration_date: '2019-12-25T23:35:48Z',
  offer_id: 92,
  offer_status: OFFER_STATUSES.PENDING,
  offer_type: OFFER_TYPES.COUNTER,
  previous_amount: 200000.0,
  previous_offer_id: 89,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-20T23:35:48Z',
  user_type: USER_TYPES.SELLER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

// Fixtures for 'Inactive' tab
export const offerDeclinedBySeller = (
  dataOverride = {},
  propertyOverride = {}
) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.REVIEWED_BY_SELLER,
      created_by: 6348361,
      created_date: '2019-12-27T20:43:25Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:43:25Z',
      user_type: USER_TYPES.SELLER,
    },
    {
      activity_comment: 'Offer amount is too low.',
      activity_type: ACTIVITY_TYPES.DECLINED,
      created_by: 6348361,
      created_date: '2019-12-27T20:45:33Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:45:33Z',
      user_type: USER_TYPES.SELLER,
    },
  ],
  amount: 200000,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-27T20:40:27Z',
  mlh_property_id: 5034627,
  offer_expiration_date: '2020-01-03T20:40:27Z',
  offer_id: 117,
  offer_status: OFFER_STATUSES.DECLINED,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-27T20:45:33Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const offerAutoDeclined = (
  dataOverride = {},
  propertyOverride = {}
) => ({
  created_date: '2020-03-03T18:05:35Z',
  updated_date: '2020-03-03T18:07:15Z',
  created_by: 9906433,
  updated_by: 3511443,
  offer_id: 1031,
  mlh_property_id: 5230640,
  buyer_party_id: 22622973,
  offer_type: 'INITIAL',
  amount: 800000.0,
  offer_expiration_date: '2020-03-10T18:05:35Z',
  offer_status: 'AUTO_DECLINE',
  user_type: 'BUYER',
  property: propertyFixture(propertyOverride),
  activities: [
    {
      created_date: '2020-03-03T18:05:35Z',
      updated_date: '2020-03-03T18:05:35Z',
      created_by: 9906433,
      updated_by: 9906433,
      activity_type: 'SUBMITTED',
      user_type: 'BUYER',
    },
    {
      created_date: '2020-03-03T18:07:04Z',
      updated_date: '2020-03-03T18:07:04Z',
      created_by: 3511443,
      updated_by: 3511443,
      activity_type: 'REVIEWED',
      user_type: 'SELLER',
    },
    {
      created_date: '2020-03-03T18:07:15Z',
      updated_date: '2020-03-03T18:07:15Z',
      created_by: 3511443,
      updated_by: 3511443,
      activity_comment: 'Auto-declined due to seller accepting another offer',
      activity_type: 'AUTO_DECLINE',
      user_type: 'SYSTEM',
    },
  ],
  ...dataOverride,
})

export const counterOfferDeclinedByBuyer = (
  dataOverride = {},
  propertyOverride = {}
) => ({
  activities: [
    {
      activity_comment: 'Final offer amount is too high',
      activity_type: ACTIVITY_TYPES.DECLINED,
      created_by: 6348361,
      created_date: '2019-12-27T20:46:46Z',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:46:46Z',
      user_type: USER_TYPES.BUYER,
    },
  ],
  amount: 350000,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-27T20:46:19Z',
  mlh_property_id: 5034635,
  offer_expiration_date: '2020-01-01T20:46:19Z',
  offer_id: 121,
  offer_status: OFFER_STATUSES.DECLINED,
  offer_type: OFFER_TYPES.COUNTER,
  previous_amount: 300000,
  previous_offer_id: 118,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-27T20:46:46Z',
  user_type: USER_TYPES.SELLER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const expiredOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [],
  amount: 500000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-11-26T23:16:19Z',
  mlh_property_id: 5034623,
  offer_expiration_date: '2019-12-01T23:16:19Z',
  offer_id: 24,
  offer_status: OFFER_STATUSES.EXPIRED,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 0,
  updated_date: '2019-12-02T00:00:01Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const expiredCounterOffer = (
  dataOverride = {},
  propertyOverride = {}
) => ({
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const withdrawnOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.WITHDRAWN,
      created_by: 6348361,
      created_date: '2019-12-09T22:50:38Z',
      updated_by: 6348361,
      updated_date: '2019-12-09T22:50:38Z',
      user_type: USER_TYPES.BUYER,
    },
  ],
  amount: 900000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-09T22:31:30Z',
  mlh_property_id: 4758593,
  offer_expiration_date: '2019-12-14T22:31:30Z',
  offer_id: 41,
  offer_status: OFFER_STATUSES.WITHDRAWN,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-09T22:50:38Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

// TODO: Replace me once OI-222 is complete
export const canceledOffer = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.SELLER_CANCELED,
      created_by: 6348361,
      created_date: '2019-12-09T22:50:38Z',
      updated_by: 6348361,
      updated_date: '2019-12-09T22:50:38Z',
      user_type: USER_TYPES.SELLER,
    },
  ],
  amount: 800000,
  buyer_party_id: 99,
  created_by: 80,
  created_date: '2019-10-24T09:30:56Z',
  mlh_property_id: 800,
  offer_expiration_date: '2019-10-31T09:30:56Z',
  offer_id: 13,
  offer_status: OFFER_STATUSES.SELLER_CANCELED,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 80,
  updated_date: '2019-10-24T09:30:56Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const offerThatFellOut = (dataOverride = {}, propertyOverride = {}) => ({
  activities: [
    {
      activity_type: 'REVIEWED',
      created_by: 6348361,
      created_date: '2019-12-27T20:45:06Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:45:06Z',
      user_type: 'SELLER',
    },
    {
      activity_type: 'ACCEPTED',
      created_by: 6348361,
      created_date: '2019-12-27T20:49:16Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:49:16Z',
      user_type: 'SELLER',
    },
    {
      activity_type: 'FALLOUT',
      created_by: 6348361,
      created_date: '2019-12-27T20:51:33Z',
      updated_by: 6348361,
      updated_date: '2019-12-27T20:51:33Z',
      user_type: 'BUYER',
    },
  ],
  amount: 400000,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-27T20:42:55Z',
  mlh_property_id: 4755604,
  offer_expiration_date: '2020-01-03T20:42:55Z',
  offer_id: 120,
  offer_status: OFFER_STATUSES.FALLOUT,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  updated_by: 6348361,
  updated_date: '2019-12-27T20:51:34Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const counterOfferThatFellOut = (
  dataOverride = {},
  propertyOverride = {}
) => ({
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

// Fixtures for "Won" tab
export const offerAcceptedBySeller = (
  dataOverride = {},
  propertyOverride = {},
  biddingStatusOverride = {}
) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.REVIEWED_BY_SELLER,
      created_by: 6348361,
      created_date: '2019-12-20T23:58:38Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-20T23:58:38Z',
      user_type: USER_TYPES.SELLER,
    },
    {
      activity_type: ACTIVITY_TYPES.ACCEPTED,
      created_by: 6348361,
      created_date: '2019-12-21T00:05:17Z',
      seller_external_user_id: '0051W000004Yfj1QAC',
      updated_by: 6348361,
      updated_date: '2019-12-21T00:05:17Z',
      user_type: USER_TYPES.SELLER,
    },
  ],
  amount: 200000.0,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-20T23:54:45Z',
  mlh_property_id: 5034621,
  offer_expiration_date: '2019-12-27T23:54:45Z',
  offer_id: 93,
  offer_status: OFFER_STATUSES.ACCEPTED,
  offer_type: OFFER_TYPES.INITIAL,
  property: propertyFixture(propertyOverride),
  biddingStatus: biddingStatusFixture(biddingStatusOverride),
  updated_by: 6348361,
  updated_date: '2019-12-21T00:05:17Z',
  user_type: USER_TYPES.BUYER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})

export const counterOfferAcceptedByBuyer = (
  dataOverride = {},
  propertyOverride = {},
  biddingStatusOverride = {}
) => ({
  activities: [
    {
      activity_type: ACTIVITY_TYPES.ACCEPTED,
      created_by: 6348361,
      created_date: '2019-12-21T00:07:13Z',
      updated_by: 6348361,
      updated_date: '2019-12-21T00:07:13Z',
      user_type: USER_TYPES.BUYER,
    },
  ],
  amount: 550000,
  buyer_party_id: 22622973,
  created_by: 6348361,
  created_date: '2019-12-21T00:06:40Z',
  mlh_property_id: 5034625,
  offer_expiration_date: '2019-12-25T00:06:40Z',
  offer_id: 96,
  offer_status: OFFER_STATUSES.ACCEPTED,
  offer_type: OFFER_TYPES.COUNTER,
  previous_amount: 500000,
  previous_offer_id: 95,
  property: propertyFixture(propertyOverride),
  biddingStatus: biddingStatusFixture(biddingStatusOverride),
  updated_by: 6348361,
  updated_date: '2019-12-21T00:07:13Z',
  user_type: USER_TYPES.SELLER,
  buyers_premium: 20000,
  earnest_money_deposit: 5000,
  ...dataOverride,
})
